<template>
  <div id="centerCenter" class="content-box-item">
    <el-image class="box-item-bg" :src="require('@/assets/images/bg-2.png')" fit="fit"/>
    <div class="center-left">
      <span class="text-1">20天未到店：{{cdata.notSingIn20DayCount}} 人</span>
      <span class="text-2">30天未到店：{{cdata.notSingIn30DayCount}} 人</span>
      <span class="text-1">.</span>
      <span class="text-1">.</span>
      <div class="button-con">耗课回访</div>
    </div>
    <div class="center-right">
      <el-image class="big-icon" :src="require('@/assets/icons/big-icon-2.png')" fit="fit"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  //
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {



      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#centerCenter {
  width: calc(100% - 30px);
  margin-left: 15px;
  .box-item-bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }
  .center-left{
    width: 52%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    padding-left: 30px;
    z-index: 1;
  }
  .center-right{
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }
  .text-1{
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    background-image:-webkit-linear-gradient(left,#f49b0b, #f7b954);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .text-2{
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    color: #707070;
  }
  .button-con{
    width: 154px;
    height: 60px;
    font-size: 22px;
    line-height: 60px;
    text-align: center;
    margin-top: 30px;
    border-radius: 10px;
    color: #FFFFFF;
    background: linear-gradient(120.93deg, #f49b0b 3.98%, #f7b954 100%);
    /* 卡片阴影 */
    box-shadow: 0px 0px 8px 2px rgba(238, 56, 35, 0.09);
  }
  .big-icon{
    margin-top: 45px;
    margin-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/center/centerCenter.vue